import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import HotelRoomMappingTooltip from '@app/site/secured/rateshopper/rates/settings/page/room-mapping/component/HotelRoomMappingTooltip';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import Utilities from '@util/Utilities';
import HotelRoomWithMapping from '@app/model/company_hotel_room_mappings_type_configuration/HotelRoomWithMapping';

const RoomTag: React.FunctionComponent<{
	roomMapping: HotelRoomWithMapping,
	isOverlay?: boolean,
	listeners?: SyntheticListenerMap | undefined,
	attributes?: DraggableAttributes | undefined
}>
	= ({ roomMapping, isOverlay = false, listeners, attributes }) => {

	const render = () => <>
		<div
			className={Utilities.classNames("inline-flex items-center rounded-l-md bg-blue-50 px-2 py-1.5 text-xs leading-tight font-medium text-blue-700 border border-r-0 border-gray-300", isOverlay? "opacity-50" : "")}>
			<button className="flex-shrink-0 self-start mr-2" {...attributes} {...listeners}>
				<img
					className="block h-4 w-auto cursor-grab"
					src="/assets/img/grid-dots.svg"
					alt="RoomPulse"
				/>
			</button>
			<span>{roomMapping.roomName}</span>
		</div>
		<div data-tooltip-id={roomMapping.roomId + '_tooltip'}
				 className="flex-shrink-0 rounded-none rounded-r-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 px-2">
			<InformationCircleIcon className="h-4 w-4 text-blue-500 cursor-pointer" />
		</div>
		<HotelRoomMappingTooltip id={roomMapping.roomId + '_tooltip'} roomMapping={roomMapping} />
	</>;

	return isOverlay ? <div className="inline-flex">{render()}</div> : render();
};

export default RoomTag;